enum Respondent {
    Patient,
    PatientRepresentative
}

enum ConsentStatus {
    Consented,
    Refused,
    NoResponse
}
export { ConsentStatus, Respondent };
